import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import Layout from "@/site/components/Layout";
import Home from "@/site/pages/Home";
import Approach from "@/site/pages/Approach";
import Markets from "@/site/pages/Markets";
import Solutions from "@/site/pages/Solutions";
import Network from "@/site/pages/Network";
import Insights from "@/site/pages/Insights";
import InsightArticle from "@/site/pages/InsightArticle";
import About from "@/site/pages/About";
import Explore from "@/site/pages/Explore";
import Legal from "@/site/pages/Legal";

function App() {
  return (
    <BrowserRouter>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/approach" element={<Approach />} />
          <Route path="/markets" element={<Markets />} />
          <Route path="/solutions" element={<Solutions />} />
          <Route path="/network" element={<Network />} />
          <Route path="/insights" element={<Insights />} />
          <Route path="/insights/:slug" element={<InsightArticle />} />
          <Route path="/about" element={<About />} />
          <Route path="/explore-opportunities" element={<Explore />} />
          <Route path="/legal" element={<Legal />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}

export default App;
